

<!-- Desktop course overview bottom popup -->
@if (!ctaDisplay && showPriceCta && courseOverviewPopup) {
  <div
    cond-class
    [target]="'body'"
    [addClass]="'mb-20'"
    class="fixed hidden md:block desktop-overview bottom-0 bg-white z-50 top-product__bottom-banner sm:right-[48px] w-full sm:w-[470px] rounded-t-md"
    [class.minimized]="isCoursePopupMinimized"
    >
    <!-- Desktop course popup banner -->
    <div class="popup-banner hidden p-4 bg-vis-top sm:flex flex-row items-center rounded-t-md relative">
      <div class="save-badge">
        <span
          class="rounded-full bg-ace-teal-200 text-sm font-extrabold text-vis-top px-3 py-2 mr-2.5 inline-block leading-none"
          >SALE!</span
          >
        </div>
        <div class="savings text-vis-reverse font-bold text-baselg" [innerHTML]="percentSavedText"></div>
        <div
          class="icon-container h-[44px] w-[44px] ml-auto right-0 flex items-center absolute"
          (click)="toggleCourseOverviewMinimize()"
          >
          <fa-icon
            class="fa-sm text-vis-reverse cursor-pointer mx-auto"
            [icon]="isCoursePopupMinimized ? faChevronUp : faChevronDown"
          ></fa-icon>
        </div>
      </div>
      <!-- Course popup content -->
      <div class="content py-v-spacing mx-v-spacing mx-auto flex flex-row items-center">
        <div class="flex flex-col w-full sm:w-auto">
          @if (data.eyebrow) {
            <div class="wysiwyg inline-block" [innerHTML]="data.eyebrow"></div>
          }
          <div class="wysiwyg popup-title mb-v-spacing" [innerHTML]="data.sectionTitle"></div>
          @if (data.showTrustpilotStars) {
            <div class="mb-v-spacing">
              <top-section-trustpilot
                [data]="data"
              ></top-section-trustpilot>
            </div>
          }
          <!-- Course popup pricing -->
          <div class="flex pricing top-product__pricing mb-6">
            <div #prices (click)="activateModalWrapper($event)" class="flex items-center prices" [innerHtml]="pricingText"></div>
          </div>
          <!-- Course popup CTA and guarantee modal link -->
          <div class="flex flex-col sm:flex-row sm:items-center">
            <vision-button defaultStyle="primary" [data]="ctaButtonData"></vision-button>
            @if (!data.hideGuaranteeLink && !(this.wistiaButtonData?.wistiaId && this.ctaButtonData)) {
              <button
                (click)="activateModal(data.modalContent)"
                class="tertiary-button font-bold w-fit ml-3 sm:w-auto mt-4 sm:mt-0 !text-base"
                [class.cursor-pointer]="data.modalContent"
                >
                {{ moneyGuaranteeLabel }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Mobile Course overview bottom popup -->
  @if (!ctaDisplay && showPriceCta && courseOverviewPopup) {
    <div
      cond-class
      [target]="'body'"
      [addClass]="'mb-20'"
      class="fixed block md:hidden mobile-overview bottom-0 bg-white z-50 top-product__bottom-banner md:right-[48px] w-full md:w-[470px] rounded-t-md"
      [class.minimized]="isMobileCoursePopupMinimized"
      >
      <!-- Mobile course popup banner -->
      <div
        class="mobile-popup-banner p-4 bg-vis-top flex md:hidden flex-row items-center rounded-t-md relative"
        [ngClass]="{ hidden: isMobileCoursePopupMinimized }"
        >
        <div class="save-badge">
          <span
            class="rounded-full bg-ace-teal-200 text-sm font-extrabold text-vis-top px-3 py-2 mr-2.5 inline-block leading-none"
            >SALE!</span
            >
          </div>
          <div class="savings text-vis-reverse font-bold text-baselg" [innerHTML]="percentSavedText"></div>
          <div
            class="icon-container h-[44px] w-[44px] ml-auto right-0 flex items-center absolute"
            (click)="toggleMobileCourseOverviewMinimize()"
            >
            <fa-icon
              class="fa-sm text-vis-reverse cursor-pointer mx-auto"
              [icon]="isMobileCoursePopupMinimized ? faChevronUp : faChevronDown"
            ></fa-icon>
          </div>
        </div>
        <!-- Minimized mobile course popup banner -->
        <div
          class="mobile-popup-banner-minimized p-4 bg-white flex md:hidden flex-row items-center rounded-t-md"
          [ngClass]="{ hidden: !isMobileCoursePopupMinimized }"
          >
          <div class="text-vis-regular font-extrabold text-lg line-through">${{ originalPrice }}</div>
          <div class="text-vis-top font-extrabold text-lg ml-3">${{ discountPrice }}</div>
          <vision-button class="popup-cta ml-6" defaultStyle="primary" [data]="ctaButtonData"></vision-button>
          <div
            class="icon-container h-[44px] w-[44px] ml-auto right-0 flex items-center absolute"
            (click)="toggleMobileCourseOverviewMinimize()"
            >
            <fa-icon
              class="fa-sm text-black cursor-pointer mx-auto"
              [icon]="isMobileCoursePopupMinimized ? faChevronUp : faChevronDown"
            ></fa-icon>
          </div>
        </div>
        <!-- Course popup content -->
        <div class="content py-v-spacing mx-v-spacing mx-auto flex flex-row items-center">
          <div class="flex flex-col w-full sm:w-auto">
            @if (data.eyebrow) {
              <div class="wysiwyg inline-block" [innerHTML]="data.eyebrow"></div>
            }
            <div class="wysiwyg popup-title mb-v-spacing" [innerHTML]="data.sectionTitle"></div>
            @if (data.showTrustpilotStars) {
              <div class="mb-v-spacing">
                <top-section-trustpilot
                  [data]="data"
                ></top-section-trustpilot>
              </div>
            }
            <!-- Course popup pricing -->
            <div class="flex pricing top-product__pricing mb-6">
              <div #prices  (click)="activateModalWrapper($event)" class="flex items-center prices" [innerHtml]="pricingText"></div>
            </div>
            <!-- Course popup CTA and guarantee modal link -->
            <div class="flex flex-col sm:flex-row sm:items-center">
              <vision-button defaultStyle="primary" [data]="ctaButtonData"></vision-button>
              @if (!data.hideGuaranteeLink && !(this.wistiaButtonData?.wistiaId && this.ctaButtonData)) {
                <button
                  (click)="activateModal(data.modalContent)"
                  class="tertiary-button font-bold w-fit m-auto sm:ml-3 sm:w-auto mt-4 sm:mt-auto !text-base"
                  [class.cursor-pointer]="data.modalContent"
                  >
                  {{ moneyGuaranteeLabel }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    }
